import { Dispatch, SetStateAction } from "react";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import useToast from "../useToast";

import { inviteUsers } from "../../services/users";

import { closeModal } from "../../store/slices/modal";

export interface IPayload {
    payload: number[];
    setIsProcessing: Dispatch<SetStateAction<boolean>>;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useInviteUsers = () => {
    const { addToast } = useToast();
    const dispatch = useDispatch();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await inviteUsers(data.payload);
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response?.statusCode === 200) {
                addToast({
                    type: 'success',
                    title: `Invitation${variables.payload.length > 1 ? 's' : ''} sent successfully.`,
                });

                dispatch(closeModal('MESSAGE_MODAL'));
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useInviteUsers;